import CustomProvider from 'components/CustomProvider';
import Button from '@alltrails/shared/denali/components/Button';
import { useIntl } from '@alltrails/shared/react-intl';
import * as styles from './DeleteAccountButtons.module.scss';

type Props = {
  cancelUrl: string;
};

const DeleteAccountButtonsInner = ({ cancelUrl }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.buttonsContainer}>
      <Button
        size="sm"
        text={intl.formatMessage({ defaultMessage: 'Keep my account' })}
        linkInfo={{ href: cancelUrl }}
        testId="cancelDeleteProfile"
        variant="primary"
      />
      <Button
        size="sm"
        text={intl.formatMessage({ defaultMessage: 'Start deletion' })}
        type="submit"
        testId="deleteProfileConfirmation"
        variant="destructive"
      />
    </div>
  );
};

export default function DeleteAccountButtons(props: Props) {
  return (
    <CustomProvider>
      <DeleteAccountButtonsInner {...props} />
    </CustomProvider>
  );
}
